// NOTE: Dependencies: jQuery, Defiant

(function ($) {
	$.fn.lmZoom = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$html: $('html')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			$context.each(function() {
				var $zoom = $(this);

				// If statement for mobile or all to target when 
				if (($zoom.hasClass('zoom--mobile') && (((settings.$html.hasClass('is-mobile')) || settings.$html.hasClass('is-tablet')) && settings.$html.hasClass('touchevents')) ) || $zoom.hasClass('zoom--all')) {

					var $zoomLink = $zoom.closest('a'),
						$zoomImage = $zoomLink.attr('href');

					$zoomLink.magnificPopup({
						type:'image',
						fixedContentPos: true,
						gallery: {
							enabled: false
						},
						image: {
						markup: 
							'<div class="mfp-figure mfp-figure--product-zoom">'+
								'<div class="mfp-close"></div>'+
								'<div class="pan-image-container">'+
									'<div class="mfp-img"></div>'+
								'</div>'+
							'</div>'
						},
						callbacks: {
							beforeOpen: function() { $('html').addClass('mfp-helper'); },
							close: function() { $('html').removeClass('mfp-helper'); },
							imageLoadComplete: function(item) {
								var $container = $('.mfp-container'),
									$image = $container.find('.pan-image-container');

								$image.panzoom({
									disableZoom: false,
									contain: false,
									minScale: 1,
									startTransform: 'scale(1.5)'
								})
							}
						}
					});

				}
			});
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});

	};

	if($('.zoom').length) {
		$('.zoom').lmZoom();
	}

}(jQuery));
